import { Alert } from '@fe-toolkit/web-components/ssr'
import styled from 'styled-components'

import { PropsWithChildren } from 'react'

import { useScrollIntoView } from '@/hooks/useScrollIntoView'

export default function AlertWithScrollIntoView({ children }: Readonly<PropsWithChildren>) {
  const alertRef = useScrollIntoView()

  return (
    <AlertWithScrollMargin ref={alertRef} variant="error">
      {children}
    </AlertWithScrollMargin>
  )
}

const AlertWithScrollMargin = styled(Alert)`
  scroll-margin-top: 4em;
`
